export default "__VITE_ASSET__CRTyRttL__"